import { RowCrudStatus } from "../../common/types";
import {
  SnapshotOverride,
  SnapshotOverrideCreateMutationVariables,
  SnapshotOverrideUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { safeJsonParse } from "../../../common/utils";

export type SnapshotOverrideValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  relatedEntityType: string;
  relatedEntityId: string;
  path: string;
  value: string;
  note: string;
  active: boolean;
};

export type SnapshotOverrideErrorsType = {
  relatedEntityType?: { message: string; fieldLabel: string };
  relatedEntityId?: { message: string; fieldLabel: string };
  path?: { message: string; fieldLabel: string };
  value?: { message: string; fieldLabel: string };
  note?: { message: string; fieldLabel: string };
  active?: { message: string; fieldLabel: string };
};

export function SnapshotOverrideValuesInit(): SnapshotOverrideValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    relatedEntityType: "",
    relatedEntityId: "",
    path: "",
    value: "{}",
    note: "",
    active: false,
  };
}

export type SnapshotOverrideType =
  | SnapshotOverride
  | SnapshotOverrideValuesType;

export function snapshotOverrideDisplayId(
  source: Partial<SnapshotOverride>,
  _langStore: LangStore
) {
  return (
    (source.relatedEntityType ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.path ?? _langStore.emptyStringSymbol)
  );
}

export function getSnapshotOverrideValues(
  source: SnapshotOverrideType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SnapshotOverrideValuesType {
  const entityValues = SnapshotOverrideValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : snapshotOverrideDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.relatedEntityType = source.relatedEntityType;
  entityValues.relatedEntityId = source.relatedEntityId;
  entityValues.path = source.path;
  entityValues.value = source.value;
  entityValues.note = source.note;
  entityValues.active = source.active || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getSnapshotOverrideUpdateVariables(
  values: SnapshotOverrideValuesType
): SnapshotOverrideUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    relatedEntityType: values.relatedEntityType,
    relatedEntityId: values.relatedEntityId,
    path: values.path,
    value: safeJsonParse(values.value, "value"),
    note: values.note,
    active: values.active,
  };
}

export function getSnapshotOverrideCreateVariables(
  values: SnapshotOverrideValuesType
): SnapshotOverrideCreateMutationVariables {
  return {
    relatedEntityType: values.relatedEntityType,
    relatedEntityId: values.relatedEntityId,
    path: values.path,
    value: safeJsonParse(values.value, "value"),
    note: values.note,
    active: values.active,
  };
}
